import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Insights } from "./types.js";
addProp(_User, "insights", Insights);
//# sourceMappingURL=users.js.map